/*
 * Copyright (c) 2024 Ask Sage, Inc. All rights reserved.
 * This software is the confidential and proprietary information of Ask Sage, Inc.
 * You shall not disclose such confidential information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Ask Sage, Inc.
 * THIS SOFTWARE IS PROVIDED "AS IS" AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL ASK SAGE, INC.
 * OR ITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
 * OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * You may not use this software except in compliance with the License.
 * You may not modify, reverse engineer, or redistribute this software.
 */
import React, { useState, useEffect } from 'react';
import { Form, FormGroup, Label, Input } from 'reactstrap';
import { ScrollableDialogContent } from '../Components/ScrollableDialogContent.js';

import { SelectPersona } from '../Chat/Components/SelectPersona.js'
import { Dialog, DialogContent, DialogTitle, Box, IconButton } from '@mui/material';
import { IoClose } from 'react-icons/io5';
import { Button } from '@mui/material';


const AddPrompt = ({ loadPrompts, personas, triggerAddPrompt, setTriggerAddPrompt, default_data, getToken }) => {

  const [loaded, setLoaded] = useState(false);
  var loaded_static = false;

  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [prompt, setPrompt] = useState('');
  const [persona, setPersona] = useState(1);
  const [public_f, setPublic] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = event => {
    event.preventDefault();
    setIsLoading(true);

    var token = getToken()
    if(token === false) {
      return;
    }

    fetch(default_data.default_prompt_service_url + '/prompt', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'x-access-tokens': `${token}`
      },
      body: JSON.stringify({
        title: title,
        description: description,
        prompt: prompt,
        persona: persona,
        public: public_f
      })
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('An error occurred while submitting.');
      })
      .then(data => {
        if(data.status != 200) {
          throw new Error(data.response);
        }
        setIsLoading(false);
        // Clear the form and display a success message
        setTitle('');
        setDescription('');
        setPrompt('');
        setPersona(1);
        setPublic(0)
        setErrorMessage('');

        loadPrompts()
        setSuccessMessage("Your prompt templated has been added!");
        const sleep = async (milliseconds) => {
          await new Promise(resolve => {
              return setTimeout(resolve, milliseconds)
          });
        };
        const run_sleep = async () => {
          closeModal()
          setSuccessMessage('')
        }
        run_sleep();
      })
      .catch(error => {
        setIsLoading(false);
        setErrorMessage(error.message);
      });
  };

  function openModal() {
    setIsOpen(true);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  function closeModal() {
    setTriggerAddPrompt(0);
    setIsOpen(false);
  }

  const handlePublic = (event) => {
    if(public_f == true || public_f == 1) {
      setPublic(0)
    }
    else {
      setPublic(1)
    }
  };
  
  useEffect(() => {
    if (triggerAddPrompt) {
      if (triggerAddPrompt === 1) {
        setIsOpen(true)
      }
    }
  }, [triggerAddPrompt]);

  useEffect(() => {

    if(loaded || loaded_static) {
      return;
    }

    setLoaded(true)
    loaded_static = true;

    }, [])

    const customStyles = {
    overlay: {
      position: 'fixed',
      zIndex: 1022,
      top: 0,
      left: 0,
      width: '100vw',
      borderRadius: '0.375rem',
      height: '100vh',
      overflow: 'hidden',
      background: 'rgba(255, 255, 255, 0.75)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    content: {
      background: '#050038',
      color: '#e9ecef',      
      width: '95%',
      height: '70%',
      margin: '5%',
      borderRadius: '30px 10px 10px 30px',
      inset: 0,
      maxWidth: 'calc(100vw - 2rem)',
      maxHeight: 'calc(100vh - 2rem)',
      overflow: 'auto',
      position: 'relative',
      border: '1px solid #ccc'
    },
  };

  return (
    <Dialog
      open={modalIsOpen}
      onClose={closeModal}
      maxWidth='lg'
      fullWidth
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <Box display={'flex'} justifyContent={'space-between'}>
            Add a Prompt Template
            <IconButton onClick={closeModal}>
              <IoClose />
            </IconButton>
        </Box>
      </DialogTitle>
      <ScrollableDialogContent modalIsOpen={modalIsOpen}>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label for="title">Title* (100 characters maximum)</Label>
            <Input required="required" size="100" type="text" value={title} onChange={event => setTitle(event.target.value)} />
          </FormGroup>
          <FormGroup>
            <Label for="description">Description* (500 characters maximum)</Label>
            <Input size="500" required="required" type="textarea" value={description} onChange={event => setDescription(event.target.value)} />
          </FormGroup>
          <FormGroup>
            <Label for="prompt">Prompt* (200,000 characters maximum)</Label>
            <Input required="required" rows="5" type="textarea" value={prompt} onChange={event => setPrompt(event.target.value)} />
          </FormGroup>
          <FormGroup>
            <Label for="persona">Persona</Label><br />
            <SelectPersona value={persona} personas={personas} onChange={event => setPersona(event.target.value)}></SelectPersona>
          </FormGroup>
          <FormGroup>
            <Label for="public_f">Public (visible to everyone)</Label>&nbsp;
            <Input type="checkbox" value="{public_f}" onChange={handlePublic} />
          </FormGroup>
          {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
          {successMessage && <p style={{ color: 'green' }}>{successMessage}</p>}
          <Button type="submit" disabled={isLoading} variant='contained'>
            {isLoading ? 'Loading...' : 'Submit'}
          </Button>
        </Form>
      </ScrollableDialogContent>
    </Dialog>
  );
}
export default AddPrompt;
